import { useLayoutEffect } from 'react';

import { useViewAs } from 'core/components/view-as';
import { setTrackingPaused } from './analytics';

// A layout effect, so the pause is set before the pages' own effects run and track on the new session.
export const usePauseTrackingDuringViewAs = () => {
  const active = Boolean(useViewAs()?.active);
  useLayoutEffect(() => {
    setTrackingPaused(active);
    return () => setTrackingPaused(false);
  }, [active]);
};
